import RemoteEvaluateResult from "./RemoteEvaluateResult"
import Entity from "../../../model/Entity"
import InAppMessageLayoutRemoteEvaluateResult from "./InAppMessageLayoutRemoteEvaluateResult"
import { InAppMessageEligibilityEvaluateResult } from "../../../evaluation/service/inappmessage/eligibility/InAppMessageEligibilityEvaluateResult"
import { InAppMessageEligibilityEvaluation } from "../../../evaluation/service/inappmessage/eligibility/InAppMessageEligibilityEvaluation"
import { DecisionReason,
  AbstractInAppMessage,
  InAppMessageContext,
  InAppMessageEvaluateContext,
  InAppMessageEventTrigger,
  InAppMessagePeriod,
  InAppMessageTimetable
} from "../../../model/model"

/**
 * Server-resolved in-app message eligibility result. Is both the entity (an in-app message) and its
 * own evaluate result, and carries the nested layout result resolved alongside it.
 */
export default class InAppMessageEligibilityRemoteEvaluateResult
  extends AbstractInAppMessage
  implements RemoteEvaluateResult, InAppMessageEligibilityEvaluateResult {
  constructor(
    readonly id: number,
    readonly key: number,
    readonly order: number,
    readonly period: InAppMessagePeriod,
    readonly timetable: InAppMessageTimetable,
    readonly eventTrigger: InAppMessageEventTrigger,
    readonly evaluateContext: InAppMessageEvaluateContext,
    readonly messageContext: InAppMessageContext,
    readonly isEligible: boolean,
    readonly reason: DecisionReason,
    readonly references: Entity[],
    readonly layout: InAppMessageLayoutRemoteEvaluateResult
  ) {
    super()
  }

  toEvaluation(): InAppMessageEligibilityEvaluation {
    return new InAppMessageEligibilityEvaluation(this, this)
  }
}
